export default __webpack_public_path__ + "static/media/V550_CoC.15ce2677.pdf";